module.exports = __webpack_public_path__ + "img/blog-65 (1).843d927e.jpg";